import type { FolderPermissions } from '../services/folder-api';

const folderPermissionRegistry = new Map<string, FolderPermissions>();

function folderPermissionRegistryKey(workspaceId: string, folderId: string) {
  return `${workspaceId}:${folderId}`;
}

export function rememberFolderPermissions(
  workspaceId: string,
  folderId: string,
  permissions: FolderPermissions | null
) {
  const key = folderPermissionRegistryKey(workspaceId, folderId);
  if (permissions) {
    folderPermissionRegistry.set(key, permissions);
  } else {
    folderPermissionRegistry.delete(key);
  }
}

export function getRememberedFolderPermissions(
  workspaceId: string,
  folderId: string
) {
  return folderPermissionRegistry.get(
    folderPermissionRegistryKey(workspaceId, folderId)
  );
}
